import { render, staticRenderFns } from "./associatedMore.vue?vue&type=template&id=5203da79&scoped=true&"
import script from "./associatedMore.vue?vue&type=script&lang=js&"
export * from "./associatedMore.vue?vue&type=script&lang=js&"
import style0 from "./associatedMore.vue?vue&type=style&index=0&lang=stylus&"
import style1 from "./associatedMore.vue?vue&type=style&index=1&id=5203da79&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5203da79",
  null
  
)

export default component.exports